{
  "user-profile-page": {
    "meta": {
      "title": "Profile",
      "description": "User profile"
    }
  }
}
